import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-expertpd',
  templateUrl: './expertpd.component.html',
  styleUrls: ['./expertpd.component.scss']
})
export class ExpertpdComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
